import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Card from "./card.js";
var CaptionedImage = /*#__PURE__*/function (_Card) {
  _inherits(CaptionedImage, _Card);
  var _super = _createSuper(CaptionedImage);
  function CaptionedImage(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    var _this;
    _classCallCheck(this, CaptionedImage);
    _this = _super.call(this, t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f), _this.Xt = "ab-captioned-image", _this.Yt = !0, _this.test = !1;
    return _this;
  }
  _createClass(CaptionedImage, [{
    key: "dt",
    value: function dt() {
      var t = {};
      return t[Card.ss.ts] = Card.es.hs, t[Card.ss.rs] = this.id, t[Card.ss.os] = this.viewed, t[Card.ss.cs] = this.title, t[Card.ss.ns] = this.imageUrl, t[Card.ss.ds] = this.description, t[Card.ss.ps] = this.updated, t[Card.ss.us] = this.expiresAt, t[Card.ss.URL] = this.url, t[Card.ss.ls] = this.linkText, t[Card.ss.fs] = this.aspectRatio, t[Card.ss.xs] = this.extras, t[Card.ss.bs] = this.pinned, t[Card.ss.gs] = this.dismissible, t[Card.ss.js] = this.clicked, t[Card.ss.zs] = this.language, t[Card.ss.ks] = this.altImageText, t[Card.ss.qs] = this.test, t;
    }
  }]);
  return CaptionedImage;
}(Card);
export { CaptionedImage as default };